// Before sign-in the home is a small landing page that speaks to one niche at a time,
// picked by `?mode=` so each campaign links straight to its audience
// (`/studio?mode=nutrition`). No mode, or one not listed here, is the general page
// (health and fitness). Copy per mode lives in the studio catalog: `landingTopic_<mode>`
// (the title's highlighted word), `landingField_<mode>`, `landingWho_<mode>` and
// `landingNiche_<mode>`.
export const LANDING_MODES = ['nutrition', 'gym', 'running'];
export const LANDING_DEFAULT = 'default';

export const landingMode = search => {
  const mode = new URLSearchParams(search).get('mode')?.trim().toLowerCase();
  return LANDING_MODES.includes(mode) ? mode : LANDING_DEFAULT;
};
